module.exports = __webpack_public_path__ + "static/media/workflow.139e2051.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/workflow.mp4
// module id = 373
// module chunks = 0